<template>
  <div style="background-color: #F7FAFE; height: 100%">
    <v-container fluid>
      <v-row style="max-width: 960px" class="mx-auto mt-2">
        <v-col cols="12">
          <FlexColumn :space="4">
            <Label text="Nishika Connect" size="h4" bold />
            <Label
                text="Nishikaでは、AI・データ分析領域に特化した正社員求人・業務委託案件を掲載しています。積極的に採用担当者にアプローチして、素晴らしい企業と出会ってください！"
            />
            <JobSearchForm :conditions="{jobType: 'side'}" />
          </FlexColumn>
        </v-col>
      </v-row>
    </v-container>

    <v-container fluid>
      <v-row class="mt-2">
        <v-col lg="12" offset-lg="0" xl="8" offset-xl="2">
          <v-row style="max-width: 960px; margin: auto">
            <Tabs :labels="['おすすめ求人', '新着求人']" v-model="tab" />
          </v-row>
          <v-row id="jobs">
            <v-col cols="12" class="py-0">
              <TabItems v-model="tab" style="background-color: transparent">
                <TabItem :value="0">
                  <JobOffersList :jobs="pagedRecommendJobs.results" isTopPage/>
                </TabItem>
                <TabItem :value="1">
                  <JobOffersList :jobs="pagedJobs.results" isTopPage/>
                </TabItem>
              </TabItems>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import JobOffersList from "../organisms/JobOffersList";
import ComponentMixin from "../ComponentMixin";
import { mapGetters } from "vuex";
import ApiMixin from "../../ApiMixin";
import Tabs from "../atoms/Tabs";
import TabItem from "../atoms/TabItem";
import TabItems from "../atoms/TabItems";
import Label from "../atoms/Label";
import FlexColumn from "../atoms/FlexColumn";
import JobSearchForm from "../organisms/JobSearchForm"

export default {
  mixins: [ComponentMixin, ApiMixin],
  type: "page",
  name: "FukugyoPage",
  components: {
    FlexColumn,
    Label,
    TabItems,
    TabItem,
    Tabs,
    JobOffersList,
    JobSearchForm,
  },
  data () {
    return {
      page: 1,
      recommendPage: 1,
      loading: false,
      tab: 0
    }
  },
  computed: {
    ...mapGetters("jobs", ["pagedJobs", "pagedRecommendJobs"]),
    ...mapGetters("user", ["user"]),
    loggedIn () {
      return this.$auth.isAuthenticated
    },
    jobs() {
      if (this.tab === 0) {
        return this.pagedRecommendJobs
      }
      return this.pagedJobs
    },
    jobsPage() {
      if (this.tab === 0) {
        return this.recommendPage
      }
      return this.page
    }
  },
  methods: {
    login () {
      this.$auth.loginWithRedirect({
        ui_locales: this.$i18n.locale,
        initialScreen: 'signUp',
      });
    },
    async loadJobs () {
      if (this.tab === 1 && this.pagedJobs.results.length === 0 || this.pagedJobs.next) {
        await this.loadPagedJobs(this.page, null, [], {}, null, "side")
      }
      if (this.tab === 0 && this.pagedRecommendJobs.results.length === 0 || this.pagedRecommendJobs.next) {
        await this.loadPagedRecommendJobs(this.recommendPage, "side")
      }
    },
    async onScroll(){
      if (this.loading) return

      const windowHeight =
        document.documentElement.clientHeight || document.body.clientHeight;
      const targetBottom = document.querySelector('#jobs').getBoundingClientRect().bottom
      if ( windowHeight >= targetBottom && this.jobsPage < (Math.floor((this.jobs.count - 1) / 10)) + 1) {
        this.loading = true
        this.setJobsPage(this.jobsPage + 1)
        await this.loadJobs();
        this.loading = false
      }
    },
    setJobsPage(page) {
      if (this.tab === 0) {
        this.recommendPage = page
      } else {
        this.page = page
      }
    }
  },
  watch: {
    "$auth.loading": {
      handler: function(loading) {
        if (!loading) {
          this.loadPagedJobs(1, null, [], {}, null, "side")
          this.loadPagedRecommendJobs(1, "side")
          if(this.$route.query.act=== 'signup') {
            this.$auth.loginWithRedirect({
              ui_locales: this.$i18n.locale,
              initialScreen: 'signUp',
            })
          }
        }
      },
      immediate: true
    },
  },
  mounted() {
    window.addEventListener('scroll', this.onScroll,true)
  },
  destroyed () {
    window.removeEventListener('scroll',this.onScroll,true)
  },
};
</script>

<style scoped lang="sass">
.sub-title-list h3
    font-size: 18px
.banner
  background-image: url('../../assets/candidate_firstview.png')
  background-repeat: no-repeat
  background-size: cover
  background-position: center center
  width: 100vw
  height: 400px

  &-title
    text-align: center
    color: white
    font-size: 24pt
    font-weight: bold

  &-text
    color: white
    font-size: 18pt
    padding-right: 80px

.v-enter-active
  transition: opacity 2s
.v-enter
  opacity: 0
</style>
